import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { UserRecord } from '../../user.model';
import { AddNewFamilyMemberDialogComponent } from '../add-new-family-member-dialog/add-new-family-member-dialog.component';
import { AddExistingUserDialogComponent } from '../add-existing-user-dialog/add-existing-user-dialog.component';

interface AddFamilyMemberOption {
    id: string;
    title: string;
    icon?: string;
    body: string;
}

@Component({
    selector: 'add-family-member-selection-dialog',
    templateUrl: './add-family-member-selection-dialog.component.html',
    styleUrls: ['./add-family-member-selection-dialog.component.scss'],
})
export class AddFamilyMemberSelectionDialogComponent implements OnInit {
    destroy$ = new Subject();

    options: AddFamilyMemberOption[];

    constructor(
        private translateService: TranslateService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<AddFamilyMemberSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private data: {
            refreshFamilyLinks?: () => void;
            userRecord: UserRecord;
        },
    ) {}

    ngOnInit() {
        this.options = [
            {
                id: 'add-new-user',
                icon: 'icon-circle-plus',
                title: this.translateService.instant('pages.user-cards.add-family-member-selection-dialog.options.add-new-user.title'),
                body: this.translateService.instant('pages.user-cards.add-family-member-selection-dialog.options.add-new-user.body'),
            },
            {
                id: 'add-existing-user',
                icon: 'icon-link',
                title: this.translateService.instant('pages.user-cards.add-family-member-selection-dialog.options.add-existing-user.title'),
                body: this.translateService.instant('pages.user-cards.add-family-member-selection-dialog.options.add-existing-user.body'),
            },
        ];
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onOptionClick(option: AddFamilyMemberOption): void {
        if (option.id === 'add-new-user') {
            this.dialog
                .open(AddNewFamilyMemberDialogComponent, { panelClass: 'bciti-dialog' })
                .afterClosed()
                .subscribe(() => {
                    if (this.data?.refreshFamilyLinks) {
                        this.data.refreshFamilyLinks();
                    }
                });
        } else if (option.id === 'add-existing-user') {
            this.dialog
                .open(AddExistingUserDialogComponent, {
                    panelClass: 'bciti-dialog',
                    data: { userRecord: this.data.userRecord },
                })
                .afterClosed()
                .subscribe(() => {
                    if (this.data?.refreshFamilyLinks) {
                        this.data.refreshFamilyLinks();
                    }
                });
        }

        this.closeDialog();
    }
}
